import React, { useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import ListPageHeader from '@shared/ListPageHeader';
import ShippingAccountsList from '@shared/shipping_accounts/ShippingAccountsList';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { shippingAccountService } from '@services/admin/shippingAccountService';
import { shippingTypeService } from '@services/admin/shippingTypeService';

const AdminShippingAccountsList = () => {
  const { t } = useTranslation();
  const [triggerCreate, setTriggerCreate] = useState(null);

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['platform', 'platform.shipping_accounts']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => triggerCreate?.()}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <ShippingAccountsList
        service={shippingAccountService}
        shippingTypeService={shippingTypeService}
        role="admin"
        onCreateReady={setTriggerCreate}
      />
    </div>
  );
};

export default AdminShippingAccountsList;
